import React, { useEffect, useMemo, useState } from 'react';
import { Form, Input, Button, Spin } from 'antd';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { doResetPassword } from '../../../modules/auth/stores/thunk';
import './Auth.scss';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const CreateAccountForm = ({ token }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const [name, setName] = useState('');

  const [fetching, setFetching] = useState(true);

  const { message } = useSelector((state) => state.common);

  useEffect(() => {
    if (message) {
      history.push('/');
    }
  }, [message]);

  useEffect(() => {
    const getIt = async () => {
      setFetching(true);
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URI}/users/invite/${token}`);

        if (res.ok) {
          const data = await res.json();
          setName(data.name);
          form.setFieldValue('email', data.email);
        }
      } catch (e) {
        // no bother
      }
      setFetching(false);
    };
    getIt();
  }, []);
  const handleSubmit = (params) => {
    dispatch(doResetPassword({ ...params, token }));
  };
  const [disabled, setDisabled] = useState(true);
  const notFound = useMemo(() => !token || (!fetching && !name), [fetching, name]);

  const handleFormChange = async () => {
    // Check if the form is valid
    return new Promise(() => {
      setTimeout(() => {
        form
          .validateFields()
          .then(() => setDisabled(false))
          .catch(() => setDisabled(true));
      });
    });
  };

  return (
    <div className="ResetPasswordForm">
      <Form
        form={form}
        scrollToFirstError
        layout="vertical"
        colon={false}
        onFinish={handleSubmit}
        onValuesChange={handleFormChange}
      >
        <div className="Logo">
          <Link to="/">
            <img src={`/logo.svg`} alt="logo" />
          </Link>
        </div>
        {notFound ? (
          <div className="FormHeader" style={{ paddingBottom: 36 }}>
            <div className="Title">Somehing is wrong...</div>

            <div className="SubTitle">
              We could not verify your invitation. Please <a href="mailto:support@sparqle.com">contact us</a>
            </div>
          </div>
        ) : (
          <Spin spinning={fetching}>
            <div className="FormHeader">
              <div className="Title">Hi {name}</div>
              <div className="Title">Create your Sparqle account</div>
              <div className="SubTitle">Enter a strong password and confirm your Sparqle acount.</div>
            </div>
            <div className="FormContent">
              <Form.Item label="Email" name="email">
                <Input size="large" placeholder="Email" readonly disabled />
              </Form.Item>
              <Form.Item
                label="Password"
                name="password"
                rules={[
                  { min: 12, message: 'At least 12 characters' },
                  { pattern: /[a-z]/, message: 'Should contain lowercase character' },
                  { pattern: /[A-Z]/, message: 'Should contain uppercase character' },
                  { pattern: /[0-9]/, message: 'Should contain number' },
                  {
                    pattern: /[!@#$%^&*()\-_<>~]/,
                    message: 'Should contain a special character like  !@#$%^&*()-_<>~',
                  },
                  { required: true, message: 'Required' },
                ]}
              >
                <Input.Password size="large" placeholder="Password" />
              </Form.Item>
            </div>
            <div className="FormFooter">
              <Button type="primary" htmlType="submit" block size="large" disabled={disabled}>
                Confirm account
              </Button>
            </div>
          </Spin>
        )}
      </Form>
    </div>
  );
};

export default CreateAccountForm;
